import { videoFileSrc } from "@/lib/media";

const Clip = ({ label, media }) => {
  const src = videoFileSrc(media);
  return (
    <div className="relative aspect-video bg-black overflow-hidden" data-testid={`showcase-${label.toLowerCase()}`}>
      {src ? (
        <video
          src={src}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          className="absolute inset-0 w-full h-full object-cover"
        />
      ) : (
        <iframe
          src={media.embed_url}
          title={`${label} — ARK Furniture Revival`}
          allow="autoplay; fullscreen; picture-in-picture"
          className="absolute inset-0 w-full h-full pointer-events-none"
          loading="lazy"
        />
      )}
      <span
        className={`absolute top-4 left-4 text-[10px] uppercase tracking-[0.25em] font-bold px-3 py-1.5 ${
          label === "After" ? "bg-[#c19a6b] text-white" : "bg-black/70 text-white"
        }`}
      >
        {label}
      </span>
    </div>
  );
};

// Silent, looping Before | After clips shown directly under the header of every customer quote.
export const ShowcaseHero = ({ showcase }) => {
  if (!showcase) return null;
  const clips = [["Before", showcase.before], ["After", showcase.after]].filter(([, m]) => m);
  if (clips.length === 0) return null;
  return (
    <section className="bg-black" data-testid="showcase-hero">
      <div className={`mx-auto grid gap-px ${clips.length === 2 ? "max-w-6xl sm:grid-cols-2" : "max-w-3xl"}`}>
        {clips.map(([label, media]) => <Clip key={label} label={label} media={media} />)}
      </div>
    </section>
  );
};
